import { render, staticRenderFns } from "./HousesEdit.vue?vue&type=template&id=21588195&scoped=true&"
import script from "./HousesEdit.vue?vue&type=script&lang=js&"
export * from "./HousesEdit.vue?vue&type=script&lang=js&"
import style0 from "./HousesEdit.vue?vue&type=style&index=0&id=21588195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21588195",
  null
  
)

component.options.__file = "HousesEdit.vue"
export default component.exports